

{
  "familyId": "MET-OMTREK-RECHT",
  "questions": [
    {
      "id": "MET-OMTREK-RECHT-001",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een rechthoek is 12 cm lang en 4 cm breed. Wat is de omtrek?",
      "context": null,
      "options": ["32 cm", "48 cm", "16 cm", "28 cm"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "geo",
          "data": { "width": 12, "height": 4, "showGrid": false, "unit": "cm" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek rechthoek",
            "content": "Omtrek = alle zijden bij elkaar optellen.\nEen rechthoek heeft 2 lange en 2 korte zijden.\nFormule: omtrek = 2 × (lengte + breedte)\nHier: 2 × (12 + 4) = 2 × 16 = 32 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_rechthoek_basis",
      "variantIndex": 1,
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "met.area-perimeter-confusion", "label": "Omtrek met oppervlakte verward", "optionIndex": 1 },
          { "id": "met.omtrek-aantal-zijden-fout", "label": "Maar één paar zijden opgeteld", "optionIndex": 2 },
          { "id": "met.omtrek-aantal-zijden-fout", "label": "Een zijde vergeten", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Omtrek = alle zijden bij elkaar. 12 + 4 + 12 + 4 = 32 cm. Met formule: omtrek = 2 × (lengte + breedte) = 2 × 16 = 32 cm. Waarom × 2? Een rechthoek heeft twee paar gelijke zijden.",
        "solutionSteps": [
          "Schrijf de formule op: omtrek = 2 × (lengte + breedte)",
          "Vul in: 2 × (12 + 4) = 2 × 16",
          "Bereken: 2 × 16 = 32 cm",
          "Controleer: 12 + 4 + 12 + 4 = 32 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! Omtrek = 2 × (12 + 4) = 32 cm.",
          "1": "48 = 12 × 4: dat is de oppervlakte (in cm²), niet de omtrek. Omtrek = optellen, oppervlakte = vermenigvuldigen.",
          "2": "16 = 12 + 4: dat is maar één paar zijden. Een rechthoek heeft 4 zijden. Omtrek = 2 × (l + b) = 32 cm.",
          "3": "28 = 12 + 4 + 12: je vergat de laatste korte zijde. Een rechthoek heeft 4 zijden: 12 + 4 + 12 + 4 = 32 cm."
        }
      }
    },
    {
      "id": "MET-OMTREK-RECHT-002",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een tuinier wil een hek plaatsen rondom een rechthoekig bloembed van 8 m lang en 3 m breed. Hoeveel meter hek heeft hij nodig?",
      "context": "tuinier",
      "options": ["24 m", "11 m", "22 m", "32 m"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "geo",
          "data": { "width": 8, "height": 3, "showGrid": false, "unit": "m" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek in het echt",
            "content": "Een hek rondom een rechthoek = de omtrek.\nOmtrek = 2 × (lengte + breedte)\n= 2 × (8 + 3) = 2 × 11 = 22 m.\n'Rondom' = omtrek!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_rechthoek_context",
      "variantIndex": 2,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.area-perimeter-confusion", "label": "Omtrek met oppervlakte verward", "optionIndex": 0 },
          { "id": "met.omtrek-aantal-zijden-fout", "label": "Maar één paar zijden opgeteld", "optionIndex": 1 },
          { "id": "met.area-calculation-error", "label": "Rekenfout bij omtrek", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Een hek rondom een bloembed = de omtrek. Omtrek = 2 × (8 + 3) = 22 m. Het hek loopt langs alle vier de zijden — dat is één rondje om het bed.",
        "solutionSteps": [
          "Herken: 'rondom' = omtrek berekenen",
          "Formule: omtrek = 2 × (lengte + breedte)",
          "Vul in: 2 × (8 + 3) = 2 × 11 = 22 m",
          "Controleer: 8 + 3 + 8 + 3 = 22 m ✓"
        ],
        "distractorExplanations": {
          "0": "24 = 8 × 3 is de oppervlakte (in m²). De vraag gaat over hoeveel meter hek — dat is de omtrek: 22 m.",
          "1": "11 = 8 + 3 is maar één paar zijden. Het hek gaat helemaal rondom: 2 × 11 = 22 m.",
          "2": "Goed! 2 × (8 + 3) = 22 m hek nodig.",
          "3": "32 klopt niet — de omtrek is 2 × (8 + 3) = 22 m. Omtrek = optellen, niet vermenigvuldigen."
        }
      }
    },
    {
      "id": "MET-OMTREK-RECHT-003",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een rechthoek heeft een omtrek van 30 cm. De lengte is 10 cm. Hoe breed is de rechthoek?",
      "context": null,
      "options": ["10 cm", "5 cm", "3 cm", "15 cm"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek terugrekenen",
            "content": "Omtrek = 2 × (lengte + breedte)\n30 = 2 × (10 + breedte)\n15 = 10 + breedte\nbreedte = 15 − 10 = 5 cm\nTruc: deel de omtrek eerst door 2!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_rechthoek_terugrekenen",
      "variantIndex": 3,
      "pedagogy": {
        "dok": 3,
        "misconceptionTags": [
          { "id": "met.omtrek-terugrekenen-fout", "label": "Lengte als breedte aangenomen", "optionIndex": 0 },
          { "id": "met.omtrek-aantal-zijden-fout", "label": "Door 10 gedeeld i.p.v. door 2", "optionIndex": 2 },
          { "id": "met.omtrek-terugrekenen-fout", "label": "Lengte niet afgetrokken na ÷2", "optionIndex": 3 }
        ]
      },
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Omtrek = 2 × (lengte + breedte). Vul in: 30 = 2 × (10 + breedte). Deel beide kanten door 2: 15 = 10 + breedte. Trek 10 af: breedte = 5 cm. Truc: door 2 delen geeft je lengte + breedte samen.",
        "solutionSteps": [
          "Schrijf de formule op: omtrek = 2 × (lengte + breedte)",
          "Vul in wat je weet: 30 = 2 × (10 + breedte)",
          "Deel door 2: 15 = 10 + breedte",
          "Trek de lengte af: breedte = 15 − 10 = 5 cm",
          "Controleer: 2 × (10 + 5) = 30 cm ✓"
        ],
        "distractorExplanations": {
          "0": "Als breedte = lengte = 10, dan zou de omtrek 40 cm zijn, niet 30. De breedte is 5 cm.",
          "1": "Goed! 30 ÷ 2 = 15, en 15 − 10 = 5 cm. Check: 2 × (10 + 5) = 30 ✓",
          "2": "30 ÷ 10 = 3 lijkt logisch, maar de omtrek bevat 4 zijden, niet 10. Eerst ÷ 2 (= 15), dan lengte aftrekken: 15 − 10 = 5 cm.",
          "3": "30 ÷ 2 = 15 is een goede eerste stap, maar 15 is lengte + breedte samen. Je moet de lengte (10) er nog van aftrekken: breedte = 5 cm."
        }
      }
    },
    {
      "id": "MET-OMTREK-RECHT-004",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "multiple_choice",
      "question": "Een vierkant heeft een omtrek van 36 cm. Hoe lang is één zijde?",
      "context": null,
      "options": ["18 cm", "6 cm", "12 cm", "9 cm"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Omtrek vierkant",
            "content": "Een vierkant heeft 4 gelijke zijden.\nOmtrek = 4 × zijde\nDus: zijde = omtrek ÷ 4\nHier: 36 ÷ 4 = 9 cm.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_vierkant_terugrekenen",
      "variantIndex": 4,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.omtrek-vierkant-deler-fout", "label": "Door 2 gedeeld i.p.v. door 4", "optionIndex": 0 },
          { "id": "met.omtrek-vierkant-deler-fout", "label": "Door 6 gedeeld i.p.v. door 4", "optionIndex": 1 },
          { "id": "met.omtrek-vierkant-deler-fout", "label": "Door 3 gedeeld i.p.v. door 4 (driehoek)", "optionIndex": 2 }
        ]
      },
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.77,
      "feedback": {
        "explanationText": "Een vierkant heeft 4 gelijke zijden. Zijde = omtrek ÷ 4 = 36 ÷ 4 = 9 cm. Check: 4 × 9 = 36 ✓",
        "solutionSteps": [
          "Herken: een vierkant heeft 4 gelijke zijden",
          "Formule: zijde = omtrek ÷ 4",
          "Bereken: 36 ÷ 4 = 9 cm",
          "Controleer: 4 × 9 = 36 cm ✓"
        ],
        "distractorExplanations": {
          "0": "36 ÷ 2 = 18: dat zijn 2 zijden. Een vierkant heeft 4 zijden: 36 ÷ 4 = 9 cm.",
          "1": "36 ÷ 6 = 6: een vierkant heeft 4 zijden, niet 6. 36 ÷ 4 = 9 cm.",
          "2": "36 ÷ 3 = 12: dat zou een driehoek zijn. Een vierkant heeft 4 zijden: 36 ÷ 4 = 9 cm.",
          "3": "Goed! 36 ÷ 4 = 9 cm per zijde."
        }
      }
    },
    {
      "id": "MET-OMTREK-RECHT-005",
      "familyId": "MET-OMTREK-RECHT",
      "module": "Metriek",
      "tier": 5,
      "levelCode": "E6",
      "group": 6,
      "skill": "oppervlakte",
      "subSkill": "omtrek_rechthoek",
      "questionType": "fill_in",
      "question": "Een schilderij is 60 cm lang en 40 cm breed. Je wilt er een lijst omheen maken. Hoeveel centimeter lijst heb je nodig? Typ je antwoord.",
      "context": "kunstenaar",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["200", "200 cm", "200cm"],
        "caseSensitive": false,
        "placeholder": "... cm"
      },
      "stimulusAids": [
        {
          "type": "geo",
          "data": { "width": 60, "height": 40, "showGrid": false, "unit": "cm" }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Lijst = omtrek",
            "content": "Een lijst rondom een schilderij = de omtrek.\nOmtrek = 2 × (lengte + breedte)\n= 2 × (60 + 40) = 2 × 100 = 200 cm.\nDat is 2 meter lijst!",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "omtrek_rechthoek_context_fill",
      "variantIndex": 5,
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "met.area-perimeter-confusion", "label": "Omtrek met oppervlakte verward" },
          { "id": "met.omtrek-aantal-zijden-fout", "label": "Aantal zijden niet correct opgeteld" }
        ]
      },
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Een lijst rondom een schilderij = de omtrek. Omtrek = 2 × (60 + 40) = 200 cm = 2 meter lijst.",
        "solutionSteps": [
          "Herken: lijst rondom = omtrek berekenen",
          "Formule: omtrek = 2 × (lengte + breedte)",
          "Vul in: 2 × (60 + 40) = 2 × 100 = 200 cm",
          "Controleer: 60 + 40 + 60 + 40 = 200 cm = 2 m ✓"
        ]
      }
    }
  ]
}

